import { render, staticRenderFns } from "./childlist.vue?vue&type=template&id=50952d1c&scoped=true&"
import script from "./childlist.vue?vue&type=script&lang=js&"
export * from "./childlist.vue?vue&type=script&lang=js&"
import style0 from "./childlist.vue?vue&type=style&index=0&id=50952d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50952d1c",
  null
  
)

export default component.exports